import { Compensation, RecommendedJob } from "../JobsScreen/types";

export interface Job extends RecommendedJob {
  additional_income: string;
  annual_compensation_max: Compensation;
  annual_compensation_min: Compensation;
  apply_via: ApplyVia;
  benefits: string;
  case_status: string;
  education: string[];
  education_required: string[];
  experience_required: string;
  external_job_url: string;
  job_category_parent: string;
  job_contact_email: string;
  job_contact_name: string;
  job_contact_phone: string;
  job_contact_title: string;
  mgmt_job_go_live_datetime: number;
  offices: Office[];
  other_sections: string[];
  other_states: string[];
  overview: string;
  responsibilities: string;
  submission_deadline: number;
  tos: boolean;
  total_compensation: Compensation;
  website: string;
  years_experience: number;
}

interface Office {
  salesforce_id: string;
  name: string;
}

export enum ApplyVia {
  PGA = "PGA.org / Email Notification",
  FacilityWebsite = "Facility Website",
}
